export const CHANGE_PROGRESS = 'CHANGE_PROGRESS_ONBOARD';
export const NEXT_STEP = 'NEXT_STEP_ONBOARD';
export const PREV_STEP = 'PREV_STEP_ONBOARD';
export const SET_VALUE_STEP00 = 'SET_VALUE_STEP00_ONBOARD';
export const SET_VALUE_STEP01 = 'SET_VALUE_STEP01_ONBOARD';
export const SET_VALUE_STEP01_BUSINESS = 'SET_VALUE_STEP01_ONBOARD_BUSINESS';
export const SET_VALUE_STEP02 = 'SET_VALUE_STEP02_ONBOARD';
export const SET_VALUE_STEP03 = 'SET_VALUE_STEP03_ONBOARD';
export const SET_VALUE_STEP04 = 'SET_VALUE_STEP04_ONBOARD';
export const SET_VALUE_STEP05 = 'SET_VALUE_STEP05_ONBOARD';
export const SET_VALUE_STEP06 = 'SET_VALUE_STEP06_ONBOARD';

export const SEARCH_COMPANY_NAME = 'SEARCH_COMPANY_NAME';
export const SET_STEP01_KEYWORD = 'SET_STEP01_KEYWORD';
export const SET_COMPANIES_FOUND_VIA_NAME = 'SET_COMPANIES_FOUND_VIA_NAME';
export const SET_REGISTER_FORM = 'SET_REGISTER_FORM';

export const SET_IPINFO = 'SET_IPINFO';
export const SET_PAY_PROVIDER = 'SET_PAY_PROVIDER';

export const SET_ONBOARD_RESULT = 'SET_ONBOARD_RESULT';
export const SET_ONBOARD_COUNTRY_CODE = 'SET_ONBOARD_COUNTRY_CODE';
